import { shippingAddressTypes } from '../actions/shippingAddressAction';

const defaultState = {
  data: {},
  pickupLocations: {},
};

const shippingAddressReducer = (state = defaultState, action: any) => {
  const { data, pickupLocations } = action;

  switch (action.type) {
    case shippingAddressTypes.GET_CONFIG_ADDRESS_FIELDS_SUCCESS:
      return {
        ...state,
        data
      }
    
    case shippingAddressTypes.SET_PICKUP_LOCATION:
      return {
        ...state,
        pickupLocations
      };
  }
  return state;
};

export default shippingAddressReducer;
